export default __webpack_public_path__ + "static/media/slider-3.4ec59963.jpg";